// extracted by mini-css-extract-plugin
module.exports = {"infoItem":"InfoItem_infoItem__SnHkV","infoItemMatches":"InfoItem_infoItemMatches__3WHtR"};